<template>
  <div id="survey-item" class="contanier-survey-item text-black">
    <div @click="toggleActive">
      <div
        v-if="active || hoverQestionId === questionId"
        :class="active ? 'icon-reorder' : 'icon-reorder-hover'"
        class="handle"
      >
        <icon-drag-drop />
      </div>
      <div class="mb-0" :class="active ? 'card-survey-inner' : ''">
        <!-- !active -->
        <div v-if="!active">
          <b-row class="w-100 m-0 card-p-30px">
            <b-col cols="7" class="p-0" v-if="nameNoHtml">
              <div
                class="font-medium-4 d-flex cursor-pointer"
                :class="formQuestion.isRequired ? 'required' : ''"
                v-safe-html="formQuestion.questionName"
              ></div>
            </b-col>
            <div
              v-if="!nameNoHtml"
              data-placeholder="Question*"
              class="text-no-data font-medium-4"
            ></div>
          </b-row>
          <b-row class="m-0 card-p-30px mb-1">
            <b-col class="p-0" v-if="descNoHtml">
              <div
                class="font-medium-4"
                v-safe-html="formQuestion.questionDesc"
              ></div>
            </b-col>
            <div
              v-if="!descNoHtml"
              data-placeholder="Description"
              class="text-no-data font-medium-4"
            ></div>
          </b-row>
          <b-row>
            <b-col>
              <div class="card-p-30px" v-if="formQuestion.image.url">
                <div class="image-display-wrp">
                  <div
                    class="image-display"
                    :style="{
                      'background-image': `url(${formQuestion.image.url})`,
                    }"
                  ></div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="card-p-30px mt-1 mb-1">
            <b-col>
              <div
                v-for="(choice, index) in formQuestion.dataChoice"
                :key="choice.seqChoice"
              >
                <!-- single choice -->
                <div
                  class="d-flex justify-content-between align-item-center w-100"
                  v-if="formQuestion.type == FORMQUESTION.TYPE.SINGLE"
                >
                  <div class="d-flex w-100">
                    <div>
                      <b-form-radio
                        name="mode-radios"
                        class="mt-12px bypass"
                        disabled
                      />
                    </div>
                    <div class="w-100">
                      <div
                        v-if="formQuestion.format == FORMQUESTION.FORMAT.TEXT"
                        class="w-100"
                      >
                        <div
                          v-if="!choice.other"
                          class="mx-5px text-black font-medium-5 ml-3"
                        >
                          <div v-if="choice.choiceName">
                            {{ choice.choiceName }}
                          </div>
                          <div v-else class="no-choice-name">Answer name</div>
                        </div>
                        <b-form-input
                          v-if="choice.other"
                          v-model="choice.choiceName"
                          class="input-container disabled bypass ml-2 mx-5px w-50"
                          placeholder="Answer name"
                          disabled
                        />
                      </div>
                      <div
                        v-if="formQuestion.format == FORMQUESTION.FORMAT.IMAGE"
                        class="w-100"
                      >
                        <image-upload
                          class="mx-5px bypass"
                          v-if="!choice.other"
                          :imageUrl="choice.imageChoice.url"
                          @onUpload="onUploadImageChoice($event, choice)"
                          isChoice
                          isImageLarge
                        />
                        <b-form-input
                          v-if="choice.other"
                          v-model="choice.choiceName"
                          class="input-container disabled bypass mx-5px w-50"
                          placeholder="Answer name"
                          disabled
                        />
                      </div>
                      <div
                        v-if="
                          formQuestion.format == FORMQUESTION.FORMAT.TEXTIMAGE
                        "
                        class="w-100"
                      >
                        <div v-if="!choice.other">
                          <div class="mx-5px text-black font-medium-5 ml-3">
                            <div v-if="choice.choiceName">
                              {{ choice.choiceName }}
                            </div>
                            <div v-else class="no-choice-name">Answer name</div>
                          </div>
                          <image-upload
                            class="bypass"
                            :imageUrl="choice.imageChoice.url"
                            @onUpload="onUploadImageChoice($event, choice)"
                            isChoice
                            isImageLarge
                          />
                        </div>
                        <b-form-input
                          v-if="choice.other"
                          v-model="choice.choiceName"
                          class="input-container disabled bypass mx-5px w-50"
                          placeholder="Answer name"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- multi choice -->
                <div
                  class="d-flex justify-content-between w-100"
                  v-if="formQuestion.type == FORMQUESTION.TYPE.MULTIPLE"
                >
                  <div
                    class="d-flex align-item-center align-items-center w-100"
                  >
                    <div class="d-flex w-100">
                      <div>
                        <b-form-checkbox class="mt-12px bypass" disabled />
                      </div>
                      <div class="w-100">
                        <div
                          v-if="formQuestion.format == FORMQUESTION.FORMAT.TEXT"
                          class="w-100"
                        >
                          <div
                            v-if="!choice.other"
                            class="mx-5px text-black font-medium-5 ml-3"
                          >
                            <div v-if="choice.choiceName">
                              {{ choice.choiceName }}
                            </div>
                            <div v-else class="no-choice-name">Answer name</div>
                          </div>
                          <b-form-input
                            v-if="choice.other"
                            v-model="choice.choiceName"
                            class="input-container disabled bypass ml-2 mx-5px w-50"
                            placeholder="Answer name"
                            disabled
                          />
                        </div>
                        <div
                          v-if="
                            formQuestion.format == FORMQUESTION.FORMAT.IMAGE
                          "
                          class="w-100"
                        >
                          <image-upload
                            class="mx-5px bypass"
                            v-if="!choice.other"
                            :imageUrl="choice.imageChoice.url"
                            @onUpload="onUploadImageChoice($event, choice)"
                            isChoice
                            isImageLarge
                          />
                          <b-form-input
                            v-if="choice.other"
                            v-model="choice.choiceName"
                            class="input-container disabled bypass mx-5px w-50"
                            placeholder="Answer name"
                            disabled
                          />
                        </div>
                        <div
                          v-if="
                            formQuestion.format == FORMQUESTION.FORMAT.TEXTIMAGE
                          "
                          class="w-100"
                        >
                          <div v-if="!choice.other">
                            <div class="mx-5px text-black font-medium-5 ml-3">
                              <div v-if="choice.choiceName">
                                {{ choice.choiceName }}
                              </div>
                              <div v-else class="no-choice-name">
                                Answer name
                              </div>
                            </div>
                            <image-upload
                              class="bypass"
                              :imageUrl="choice.imageChoice.url"
                              @onUpload="onUploadImageChoice($event, choice)"
                              isChoice
                              isImageLarge
                            />
                          </div>
                          <b-form-input
                            v-if="choice.other"
                            v-model="choice.choiceName"
                            class="input-container disabled bypass mx-5px w-50"
                            placeholder="Answer name"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- text area -->
                <div
                  class="w-100"
                  v-if="formQuestion.type == FORMQUESTION.TYPE.TEXTAREA"
                >
                  <b-form-input
                    placeholder="Answer name"
                    class="text-area-type-inactive bypass"
                    disabled
                  />
                </div>

                <!-- date -->
                <div>
                  <div
                    class="d-flex align-item-center date-wrp"
                    v-if="formQuestion.type == FORMQUESTION.TYPE.DATE"
                  >
                    <div class="mr-2"><icon-date class="icon-date" /></div>
                    <div>DD-MM-YYYY</div>
                  </div>
                </div>

                <!-- dropdown -->
                <div
                  class="d-flex justify-content-between w-100"
                  v-if="formQuestion.type == FORMQUESTION.TYPE.DROPDOWN"
                >
                  <div
                    class="d-flex align-item-center justify-content-between w-100"
                  >
                    <div class="d-flex align-item-center w-100">
                      <div class="font-medium-5">{{ index + 1 }}.</div>
                      <div class="w-100">
                        <div
                          v-if="!choice.other"
                          class="mx-5px text-black font-medium-5 ml-3"
                        >
                          <div v-if="choice.choiceName">
                            {{ choice.choiceName }}
                          </div>
                          <div v-else class="no-choice-name ml-2">
                            Answer name
                          </div>
                        </div>
                        <b-form-input
                          v-if="choice.other"
                          v-model="choice.choiceName"
                          class="input-container disabled bypass ml-3 mx-5px w-50"
                          placeholder="Answer name"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- active -->
        <div v-if="active">
          <b-row class="w-100 m-0 d-flex justify-content-between card-p-30px">
            <b-col cols md="7" class="p-0 mt-1">
              <div
                v-if="!activeQuestion && !nameNoHtml"
                data-placeholder="Question*"
                class="text-no-data font-medium-4"
                @click="toggledInputFocus(activeHover.SURVEY_NAME)"
              ></div>
              <div
                v-if="!activeQuestion && nameNoHtml"
                class="font-medium-4 d-flex cursor-pointer"
                :class="formQuestion.isRequired ? 'required' : ''"
                v-safe-html="formQuestion.questionName"
                @click="toggledInputFocus(activeHover.SURVEY_NAME)"
              ></div>
              <div id="toolbar-editor" v-if="activeQuestion">
                <quill-editor
                  toolbar="#my-toolbar"
                  ref="surveyNameQuill"
                  class="custom-quill-editor flex-stretch h-100"
                  :options="customQuillOption"
                  v-model="formQuestion.questionName"
                  required
                >
                </quill-editor>
                <div id="my-toolbar">
                  <custom-toolbar />
                </div>
              </div>
            </b-col>
            <b-col cols md="5" class="p-0" @click="toggledInputFocus()">
              <div class="d-flex justify-content-end w-100">
                <b-row>
                  <b-col class="d-flex p-0">
                    <b-form-group>
                      <div id="survey-select-type" class="p-relative">
                        <single-choice-svg
                          class="icon-container"
                          v-if="formQuestion.type == FORMQUESTION.TYPE.SINGLE"
                        />
                        <multiple-choice-svg
                          class="icon-container"
                          v-if="formQuestion.type == FORMQUESTION.TYPE.MULTIPLE"
                        />
                        <text-area-svg
                          class="icon-container"
                          v-if="formQuestion.type == FORMQUESTION.TYPE.TEXTAREA"
                        />
                        <date-svg
                          class="icon-container"
                          v-if="formQuestion.type == FORMQUESTION.TYPE.DATE"
                        />
                        <dropdown-svg
                          class="icon-container"
                          v-if="formQuestion.type == FORMQUESTION.TYPE.DROPDOWN"
                        />
                        <v-select
                          class="v-select-filter bg-dropdown mr-2 p-0"
                          id="select-type"
                          v-model="formQuestion.type"
                          :options="optionQuestion.typeChoiceOption"
                          :reduce="(option) => option.value"
                          :searchable="false"
                          placeholder="Status"
                          :clearable="false"
                          @input="onChangeFormat"
                        >
                          <template slot="option" slot-scope="option">
                            <component
                              :is="option.icon"
                              class="mr-1 action-dropdown-svg"
                            />
                            <div class="pl-1">{{ option.label }}</div>
                          </template>
                        </v-select>
                      </div>
                    </b-form-group>
                    <v-select
                      v-if="
                        formQuestion.type == FORMQUESTION.TYPE.SINGLE ||
                        formQuestion.type == FORMQUESTION.TYPE.MULTIPLE
                      "
                      class="v-select-filter bg-dropdown p-0 option-choice-wrp"
                      id="select-format"
                      placeholder="Status"
                      v-model="formQuestion.format"
                      :options="optionQuestion.formatChoiceOption"
                      :reduce="(option) => option.value"
                      :searchable="false"
                      :clearable="false"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="m-0 card-p-30px">
            <b-col class="p-0">
              <div
                v-if="!activeDesc && !descNoHtml"
                data-placeholder="Desciption"
                class="text-no-data font-medium-4"
                @click="toggledInputFocus(activeHover.SURVEY_DESC)"
              ></div>
              <div
                class="font-medium-4"
                v-if="!activeDesc && descNoHtml"
                v-safe-html="formQuestion.questionDesc"
                @click="toggledInputFocus(activeHover.SURVEY_DESC)"
              ></div>
              <div id="toolbar-editor" v-if="activeDesc">
                <quill-editor
                  toolbar="#my-toolbar"
                  ref="quizDescQuill"
                  class="custom-quill-editor flex-stretch h-100"
                  :options="customQuillOption"
                  v-model="formQuestion.questionDesc"
                >
                </quill-editor>
                <div id="my-toolbar">
                  <custom-toolbar />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="card-p-30px" @click="toggledInputFocus()">
            <b-col>
              <!-- <div v-if="!showUploadImage.isShow">
              <div class="btn-add-image-wrp mt-2" @click="onShowUploadImage">
                <div class="btn-add-image mr-2">
                  <icon-plus class="icon-plus" />
                </div>
                <div class="title-btn-add-image">Add Image</div>
              </div>
            </div> -->
              <div class="mt-1">
                <div class="font-medium-4">
                  <span class="text-black mr-2">Image</span>
                  <span class="desc-title"
                    >(Format JPG, JPEG, PNG Max 2 Mb)</span
                  >
                </div>
                <image-upload
                  removable
                  :imageUrl="formQuestion.image.url"
                  @onUpload="onUploadImage($event, formQuestion)"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="card-p-30px" @click="toggledInputFocus()">
            <b-col>
              <div
                v-for="(choice, index) in formQuestion.dataChoice"
                :key="choice.seqChoice"
              >
                <!-- single choice -->
                <div
                  class="d-flex justify-content-between align-item-center w-100"
                  v-if="formQuestion.type == FORMQUESTION.TYPE.SINGLE"
                >
                  <div class="d-flex w-100">
                    <div>
                      <b-form-radio name="mode-radios" class="mt-12px bypass" />
                    </div>
                    <div class="w-100">
                      <div
                        v-if="formQuestion.format == FORMQUESTION.FORMAT.TEXT"
                        class="w-100"
                      >
                        <b-form-input
                          v-if="!choice.other"
                          v-model="choice.choiceName"
                          placeholder="Answer name"
                          class="input-type w-60 mx-5px"
                          autofocus
                        />
                        <b-form-input
                          v-if="choice.other"
                          v-model="choice.choiceName"
                          class="input-container input-type input-type-disabled w-60 ml-3"
                          placeholder="Answer name"
                          disabled
                        />
                      </div>
                      <div
                        v-if="formQuestion.format == FORMQUESTION.FORMAT.IMAGE"
                        class="w-100"
                      >
                        <image-upload
                          class="mx-5px"
                          v-if="!choice.other"
                          :imageUrl="choice.imageChoice.url"
                          @onUpload="onUploadImageChoice($event, choice)"
                          isChoice
                          isImageLarge
                        />
                        <b-form-input
                          v-if="choice.other"
                          v-model="choice.choiceName"
                          class="input-container input-type input-type-disabled w-60 ml-3"
                          placeholder="Answer name"
                          disabled
                        />
                      </div>
                      <div
                        v-if="
                          formQuestion.format == FORMQUESTION.FORMAT.TEXTIMAGE
                        "
                        class="w-100"
                      >
                        <div v-if="!choice.other">
                          <b-form-input
                            v-model="choice.choiceName"
                            placeholder="Answer name"
                            class="input-type w-60 mx-5px"
                            autofocus
                          />
                          <image-upload
                            :imageUrl="choice.imageChoice.url"
                            @onUpload="onUploadImageChoice($event, choice)"
                            isChoice
                            isImageLarge
                          />
                        </div>
                        <b-form-input
                          v-if="choice.other"
                          v-model="choice.choiceName"
                          class="input-container input-type input-type-disabled w-60 ml-3"
                          placeholder="Answer name"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-item-center">
                    <div
                      class="mr-2"
                      v-if="
                        formQuestion.linkToType ==
                        FORMQUESTION.NEXTSTEP.SETTINGBYCHOICE
                      "
                    >
                      <v-select
                        id="link-to-choice"
                        v-model="choice.nextstep_type"
                        class="v-select-filter bg-dropdown p-0"
                        placeholder="Setting by Choice"
                        :options="tagOption.optionChoice"
                        :searchable="true"
                        :clearable="false"
                        :reduce="(option) => option"
                      >
                        <template #selected-option="options">
                          <div>
                            {{
                              options.label
                                ? options.label
                                : "Setting by Choice"
                            }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div>
                      <icon-trash
                        class="icon-trash-question"
                        v-if="formQuestion.dataChoice.length > 1"
                        @click.native="onRemoveChoice(choice)"
                      />
                    </div>
                  </div>
                </div>

                <!-- multi choice -->
                <div
                  class="d-flex justify-content-between"
                  v-if="formQuestion.type == FORMQUESTION.TYPE.MULTIPLE"
                >
                  <div
                    class="d-flex align-item-center align-items-center w-100"
                  >
                    <div class="d-flex w-100">
                      <div>
                        <b-form-checkbox class="mt-12px bypass" />
                      </div>
                      <div class="w-100">
                        <div
                          v-if="formQuestion.format == FORMQUESTION.FORMAT.TEXT"
                          class="w-100"
                        >
                          <b-form-input
                            v-if="!choice.other"
                            v-model="choice.choiceName"
                            placeholder="Answer name"
                            class="input-type w-60 mx-5px"
                            autofocus
                          />
                          <b-form-input
                            v-if="choice.other"
                            v-model="choice.choiceName"
                            class="input-container input-type input-type-disabled w-60 ml-3"
                            placeholder="Answer name"
                            disabled
                          />
                        </div>
                        <div
                          v-if="
                            formQuestion.format == FORMQUESTION.FORMAT.IMAGE
                          "
                          class="w-100"
                        >
                          <image-upload
                            class="mx-5px"
                            v-if="!choice.other"
                            :imageUrl="choice.imageChoice.url"
                            @onUpload="onUploadImageChoice($event, choice)"
                            isChoice
                            isImageLarge
                          />
                          <b-form-input
                            v-if="choice.other"
                            v-model="choice.choiceName"
                            class="input-container input-type input-type-disabled w-60 ml-3"
                            placeholder="Answer name"
                            disabled
                          />
                        </div>
                        <div
                          v-if="
                            formQuestion.format == FORMQUESTION.FORMAT.TEXTIMAGE
                          "
                          class="w-100"
                        >
                          <div v-if="!choice.other">
                            <b-form-input
                              v-model="choice.choiceName"
                              placeholder="Answer name"
                              class="input-type w-60 mx-5px"
                              autofocus
                            />
                            <image-upload
                              :imageUrl="choice.imageChoice.url"
                              @onUpload="onUploadImageChoice($event, choice)"
                              isChoice
                              isImageLarge
                            />
                          </div>
                          <b-form-input
                            v-if="choice.other"
                            v-model="choice.choiceName"
                            class="input-container input-type input-type-disabled w-60 ml-3"
                            placeholder="Answer name"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-item-center">
                    <div>
                      <icon-trash
                        class="icon-trash-question"
                        v-if="formQuestion.dataChoice.length > 1"
                        @click.native="onRemoveChoice(choice)"
                      />
                    </div>
                  </div>
                </div>

                <!-- text area -->
                <div
                  class="w-100"
                  v-if="formQuestion.type == FORMQUESTION.TYPE.TEXTAREA"
                >
                  <b-form-input
                    placeholder="Answer name"
                    class="text-area-type"
                    disabled
                  />
                </div>

                <!-- date -->
                <div>
                  <div
                    class="d-flex date-wrp align-item-center"
                    v-if="formQuestion.type == FORMQUESTION.TYPE.DATE"
                  >
                    <div class="mr-2"><icon-date class="icon-date" /></div>
                    <div>DD-MM-YYYY</div>
                  </div>
                </div>

                <!-- dropdown -->
                <div
                  class="d-flex justify-content-between w-100"
                  v-if="formQuestion.type == FORMQUESTION.TYPE.DROPDOWN"
                >
                  <div
                    class="d-flex align-item-center justify-content-between w-100"
                  >
                    <div class="d-flex align-item-center w-100">
                      <div class="font-medium-5">{{ index + 1 }}.</div>
                      <div v-if="!choice.other" class="w-100">
                        <b-form-input
                          v-model="choice.choiceName"
                          class="input-type w-60"
                          placeholder="Answer name"
                          autofocus
                        />
                      </div>
                      <b-form-input
                        v-if="choice.other"
                        v-model="choice.choiceName"
                        class="input-container input-type input-type-disabled w-60 ml-3"
                        placeholder="Answer name"
                        disabled
                      />
                    </div>
                    <div class="d-flex align-item-center">
                      <div
                        class="mr-2"
                        v-if="
                          formQuestion.linkToType ==
                          FORMQUESTION.NEXTSTEP.SETTINGBYCHOICE
                        "
                      >
                        <v-select
                          id="link-to"
                          v-model="choice.nextstep_type"
                          class="v-select-filter bg-dropdown p-0"
                          placeholder="Setting by Choice"
                          :options="tagOption.optionChoice"
                          :searchable="true"
                          :clearable="false"
                          :reduce="(option) => option"
                        >
                          <template #selected-option="options">
                            <div>
                              {{
                                options.label
                                  ? options.label
                                  : "Setting by Choice"
                              }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <icon-trash
                        class="icon-trash-question"
                        v-if="formQuestion.dataChoice.length > 1"
                        @click.native="onRemoveChoice(choice)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="card-p-30px" @click="toggledInputFocus()">
            <b-col>
              <div
                v-if="
                  formQuestion.type == FORMQUESTION.TYPE.SINGLE ||
                  formQuestion.type == FORMQUESTION.TYPE.MULTIPLE ||
                  formQuestion.type == FORMQUESTION.TYPE.DROPDOWN
                "
              >
                <div class="add-choice font-medium-5">
                  <span class="mr-1 color-blue" @click="onAddChoice()"
                    >Add Answer</span
                  ><span class="mr-1" v-if="!formQuestion.isOther">or</span>
                  <span
                    class="color-blue"
                    v-if="!formQuestion.isOther"
                    @click="onAddOther()"
                    >Add Other</span
                  >
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="active" class="card-p-30px" @click="toggledInputFocus()">
            <b-col>
              <div class="d-flex justify-content-end mt-1 align-item-center">
                <div class="d-flex mr-2">
                  <div class="mr-2 font-medium-5 mt-minus-4px">Require</div>
                  <b-form-checkbox
                    v-model="formQuestion.isRequired"
                    field-value="true"
                    class="custom-control-success custom-toggle"
                    name="check-button"
                    switch
                  >
                    <span class="switch-icon-left toggle-text">{{ "" }}</span>
                    <span class="switch-icon-right toggle-text">{{ "" }}</span>
                  </b-form-checkbox>
                </div>
                <!-- <icon-duplicate
                  class="icon-duplicate-question mb-4px"
                  @click.native="onDuplicateQuestion(formQuestion)"
                /> -->
                <img
                  class="icon-duplicate-question mb-4px"
                  @click="onDuplicateQuestion(formQuestion)"
                  :src="IconCopy"
                />
                <icon-trash
                  v-if="formSection.question.length > 1"
                  class="icon-trash-question ml-4 mb-4px"
                  @click.native="
                    $emit('deleteQuestion', formQuestion.questionId)
                  "
                />
                <div class="question-choice-group mb-4px">
                  <action-group
                    class="ml-4"
                    isRadio
                    :title="'Question and Choice'"
                    :resolve-action="resolveQuestionAction"
                    :set-action-list="resolveQuestionList(formQuestion)"
                    :radioValue="formQuestion.linkToType"
                  />
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <div
                  v-if="
                    formQuestion.linkToType ==
                    FORMQUESTION.NEXTSTEP.OTHERQUESTION
                  "
                >
                  <v-select
                    id="link-to"
                    v-model="formQuestion.nextQuestionId"
                    class="v-select-filter bg-dropdown p-0"
                    placeholder="Go to other Questions"
                    :options="tagOption.optionQuestion"
                    :reduce="(option) => option.value"
                    :searchable="true"
                    :clearable="false"
                  />
                </div>
                <div
                  v-if="
                    formQuestion.linkToType ==
                    FORMQUESTION.NEXTSTEP.OTHERSECTION
                  "
                >
                  <v-select
                    id="link-to"
                    v-model="formQuestion.nextSectionId"
                    class="v-select-filter bg-dropdown p-0"
                    placeholder="Go to other Section"
                    :options="tagOption.optionSection"
                    :reduce="(option) => option.value"
                    :searchable="true"
                    :clearable="false"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Quill from "quill";
import IconDragDrop from "@/@core/components/svg/common/IconDragDrop.vue";
import CustomToolbar from "./CustomToolbarEditor.vue";
import IconTrash from "@/@core/components/svg/common/IconTrash.vue";
import IconDuplicate from "@/@core/components/svg/common/IconDuplicate.vue";
import IconDate from "@/@core/components/svg/common/IconDate.vue";
import SingleChoiceSvg from "@/@core/components/svg/question-modal/SingleChoice.vue";
import MultipleChoiceSvg from "@/@core/components/svg/survey/MultipleChoice.vue";
import TextAreaSvg from "@/@core/components/svg/survey/TextArea.vue";
import DateSvg from "@/@core/components/svg/survey/Date.vue";
import DropdownSvg from "@/@core/components/svg/survey/Dropdown.vue";
import useSurveyItem from "../hooks/useSurveyItem";
import ImageUpload from "../../quiz-info/Components/ImageUpload.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import IconCopy from "@/assets/images/icons/IconCopy.png";

export default {
  components: {
    draggable,
    IconDragDrop,
    IconTrash,
    IconDuplicate,
    IconDate,
    SingleChoiceSvg,
    MultipleChoiceSvg,
    TextAreaSvg,
    DateSvg,
    DropdownSvg,
    CustomToolbar,
    ImageUpload,
    ActionGroup,
  },
  props: {
    formQuestion: {
      type: [Object, Array],
      default: {},
    },
    formSection: {
      type: [Object, Array],
      default: {},
    },
    optionQuestion: { type: Object, default: {} },
    active: { type: Boolean, default: false },
    hoverQestionId: { type: Number, default: null },
    onHover: { type: Function, default: function () {} },
    questionId: { type: Number, default: null },
    activeEditor: { type: Object, default: {} },
    isEdit: { type: Boolean, default: false },
  },
  setup(props) {
    const {
      customQuillOption,
      toggledInputFocus,
      activeQuestion,
      activeDesc,
      activeHover,
      toggleActive,
      resolveQuestionAction,
      questionActionList,
      onAddChoice,
      onAddOther,
      onRemoveChoice,
      onUploadImage,
      onUploadImageChoice,
      onChangeFormat,
      onDuplicateQuestion,
      nameNoHtml,
      descNoHtml,
      tagOption,
      resolveQuestionList,
      FORMQUESTION,
    } = useSurveyItem(props);

    return {
      customQuillOption,
      toggledInputFocus,
      activeQuestion,
      activeDesc,
      activeHover,
      toggleActive,
      resolveQuestionAction,
      questionActionList,
      onAddChoice,
      onAddOther,
      onRemoveChoice,
      onUploadImage,
      onUploadImageChoice,
      onChangeFormat,
      onDuplicateQuestion,
      nameNoHtml,
      descNoHtml,
      tagOption,
      resolveQuestionList,
      FORMQUESTION,
      IconCopy,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/survey/survey-item.css";
@import "~@/assets/css/pages/quiz/toolbar-editor.css";
</style>